import { render, staticRenderFns } from "./NewCustomerPage.vue?vue&type=template&id=2b273bfa&scoped=true&"
import script from "./NewCustomerPage.vue?vue&type=script&lang=js&"
export * from "./NewCustomerPage.vue?vue&type=script&lang=js&"
import style0 from "./NewCustomerPage.vue?vue&type=style&index=0&id=2b273bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b273bfa",
  null
  
)

component.options.__file = "NewCustomerPage.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VContainer,
  VDialog,
  VFlex,
  VLayout,
  VSnackbar,
  VSpacer,
  VTextField,
})
